export default {
    title: 'Kreirajte novu uslugu',
    title_modify: 'Izmijenite uslugu',
    subtitle: 'Unesite podatke o usluzi',
    create_category: 'Molimo vas izaberite kategorije',
    category_types: 'Kategorije usluga:',
    progressbar: {
        service_data: 'Podaci o usluzi',
        category: 'Kategorija',
        photos: 'Slike',
        schedule: 'Raspored',
    },
    selected_category_number: 'Broj izabranih usluga: {number}',
    category_warning: 'Molimo vas dodajte bar jednu kategoriju',
    no_search_result: 'Nismo pronašli nijednu uslugu koja odgovara vašoj pretrazi',
}
